import { computed, effect, inject, Injectable, signal } from '@angular/core';
import { APP_ENVIRONMENT_PROVIDER } from '@mkp/shared/util-environment';
import { FullviewConfig, FullviewUserData, WindowWithFullview } from './fullview.model';

@Injectable({
  providedIn: 'root',
})
export class FullviewService {
  private readonly window = inject(Window) as WindowWithFullview;
  private readonly environment = inject(APP_ENVIRONMENT_PROVIDER);
  private readonly salesforceId = signal<string | undefined>(undefined);
  private readonly userData = signal<FullviewUserData | undefined>(undefined);

  private readonly fullviewConfig = computed(() => {
    const salesforceId = this.salesforceId();
    const userData = this.userData();

    return salesforceId !== undefined && userData !== undefined
      ? this.getFullviewConfig(salesforceId, userData)
      : undefined;
  });

  _ = effect(() => {
    const config = this.fullviewConfig();
    if (config) {
      this.init(config);
    }
  });

  public setFullviewUserData(userData: FullviewUserData) {
    this.userData.set(userData);
  }

  public setFullviewSalesforceId(salesforceId: string) {
    this.salesforceId.set(salesforceId);
  }

  private init(fullviewConfig: FullviewConfig) {
    this.window.$fvIdentity = fullviewConfig;
  }

  private addPrefixToUserId(userId: string): string {
    return this.environment.production ? userId : `${this.environment.name}-${userId}`;
  }

  private getFullviewConfig(salesforceId: string, userData: FullviewUserData) {
    const { userId, ...restUserData } = userData;
    return {
      id: salesforceId || this.addPrefixToUserId(userId),
      ...restUserData,
      disableReplaysForUser: false,
    };
  }
}
